import type { Address } from 'viem';

import { useTokenInfo } from '@shared/helpers/web3/erc20';

import type { RewardPool } from '@api/types/rewardPools';

export const useTokenInfoByRewardPoolSettings = ({ distribution_settings }: RewardPool) => {
  const { data: tokenInfo, isLoading: isTokenLoading } = useTokenInfo(
    {
      address: distribution_settings?.swap_token as Address,
      chainId: distribution_settings?.swap_chain,
    },
    {
      enabled:
        Boolean(distribution_settings?.swap_token) && Boolean(distribution_settings?.swap_chain),
    },
  );

  return { tokenInfo, isTokenLoading };
};
